import { Chip } from "@mui/material";
import { useRecordContext, useTranslate } from "react-admin";

import { DataSource } from "../../generated/graphql";
import { getProcedureSourceSystemColor } from "../../lib/statusColors";

interface SourceSystemChipProps<TRecord extends { sourceSystem?: DataSource | null }> {
  record?: TRecord;
  translatePrefix: string;
}

export const SourceSystemChip = <TRecord extends { sourceSystem?: DataSource | null }>({
  record,
  translatePrefix,
}: SourceSystemChipProps<TRecord>) => {
  const recordContext = useRecordContext<TRecord>();
  const translate = useTranslate();
  const resolvedRecord = record ?? recordContext;

  const sourceSystem = resolvedRecord?.sourceSystem;
  if (!sourceSystem) return null;

  return (
    <Chip
      label={translate(`${translatePrefix}.${sourceSystem.toLowerCase()}`)}
      color={getProcedureSourceSystemColor(sourceSystem)}
      size="small"
    />
  );
};
